import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IconType, IoniconsOutline} from '@pt/pt-models';
import { Attachment } from 'it/primatoo/openapi/api/org/schemas/common/Attachment';

@Component({
  selector: 'pt-widget-attachment-preview-v0',
  template: `
    <ng-container *ngIf='loading; then LOADING; else PREVIEW'></ng-container>

    <ng-template #LOADING>
      Loading ...
    </ng-template>

    <ng-template #PREVIEW>
      <div class='pt-widget-attachment-editor-v0'>

        <ng-template #NODATA>
          <pt-widget-nodata [noDataLabel]="noDataLabel"></pt-widget-nodata>
        </ng-template>

        <div class='attachments' *ngIf='preview?.length > 0 else NODATA'>
          <div class='mb-3' *ngFor='let attachment of preview'>
            <div class='attachment-container'>
              <pt-icon [size]='30'
                       [iconType]='SVG'
                       [key]='attachment?.attachmentType?.toLowerCase() + ".svg"'
              ></pt-icon>

              <div class='attachment'>
              <span [container]='"body"'
                    [ngbTooltip]='attachment?.name'>
                {{
                  attachment?.name ? attachment?.name :
                    ("MESSAGE.ATTACHMENT_WITHOUT_NAME" | translate)
                }}
              </span>

                <span class='checksum text-muted' container='body'
                      [ngbTooltip]='attachment?.checksum'
                >Checksum: {{ attachment?.checksum }}</span>
              </div>

              <div class='attachment-actions'>
                <button class='btn btn-sm btn-outline-secondary d-flex align-items-end'
                        (click)='downloadAttachment.emit(attachment)'>
                  <pt-icon [key]='IconDownload'></pt-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  `,
  styles: [`
    .pt-widget-attachment-editor-v0 {
      border: solid 1px var(--ptBorder);
      padding: 10px 10px 10px 10px;
    }

    .attachments {
      overflow: auto;
      max-height: 156px;
    }

    .attachment-container {
      display: flex;
      align-items: center;
    }

    .attachment {
      padding: 0 5px 0 4px;
      display: grid;
    }

    .checksum {
      font-size: 10px;
    }

    .attachment-actions {
      display: flex;
      align-self: end;
    }

    span {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  `]
})
export class WidgetAttachmentPreviewV0Component {
  @Input() preview: Attachment[];
  @Input() noDataLabel?: string;
  @Input() loading: boolean;
  @Output() downloadAttachment: EventEmitter<Attachment> = new EventEmitter<Attachment>();

  IconAttach = IoniconsOutline.attach;
  IconTrash = IoniconsOutline.trash;
  IconDownload = IoniconsOutline.download;
  SVG = IconType.SVG;
}
